<template>
  <domains-list/>
</template>

<script>
import DomainsList from '@/components/Domains/DomainsList'

export default {
  name: 'DomainsListView',
  components: {
    DomainsList
  }
}
</script>
